import { Injectable } from '@angular/core';

@Injectable()
export class NoopGoogleTagManagerService {
  pushTag(_tag: any) {
  }
}